@if (!summary) {
  <mat-form-field class="w-100">
    <mat-label [innerHtml]="question.editLabel | localized"></mat-label>
    <input matInput
      [readOnly]="summary"
      [id]="question.questionNumber"
      [formControl]="control"
      [value]="control?.value"
      [required]="question.isRequired"
      [matDatepicker]="picker"
      (dateChange)="onDateChange($event)">
      <mat-datepicker-toggle matPrefix
      [for]="picker"></mat-datepicker-toggle>
      <button mat-button
        matSuffix
        mat-icon-button
        (click)="control?.setValue('')"
        aria-label="Clear">
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker #picker
      disabled="false"></mat-datepicker>
      @if (!control.valid) {
        <mat-error>
          {{'form.validation.required' | translate}}
        </mat-error>
      }
    </mat-form-field>
  }

  @if (summary) {
    <p class="summary">
      <label  [innerHtml]="question.summaryLabel | localized"> : </label>
      @if (!!control.value) {
        <span>{{ control.value | date:'yyyy/MM/dd'}}</span>
      }
      @if (!control.value) {
        <span class="notFilled">N/A</span>
      }
    </p>
  }